
import { LayoutBase } from '../../layouts';
import { ToolsDetails } from '../../components/custom';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Divider, Grid, TextField, Typography } from '@mui/material';
import { ILegislation, LegislationService } from '../../services/api/legislation/Legislation';
import { useEffect, useState } from 'react';
import { CustomAlert } from '../../components/shared';
import { useAuthContext } from '../../context';
import { Download } from '@mui/icons-material';

export const LegislationDetails = () => {

    const { id } = useParams();
    const [ data, setData ] = useState<ILegislation>();
    const { userData } = useAuthContext();
    const navigate = useNavigate();

    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });

    const fetchData = () => {
        if(id !== 'novo' && id !== undefined){
            LegislationService.get(id)
                .then((response) => {
                    if(response instanceof Error){
                        console.log(response.message);
                    }else{
                        setData(response);
                        
                    }
                });
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedData = { ...data, [name]: value };
        setData(updatedData);
    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const selectedFile = e.target.files[0];            
            setData(prevData => ({
                ...prevData,
                arquivo: selectedFile,
            }));
            // const img = await convertFileToBase64(selectedFile);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleSave = () => {
        if(data && id == 'novo'){
            LegislationService.create(data)
            .then((response) => {
                if(response instanceof Error){
                    console.log(response.message);
                    setAlertInfo({ open: true, message: response.message + response.message, severity: 'error' });
                }else{
                    console.log('ok');
                    setAlertInfo({ open: true, message: 'Legislação criada! ' + response.message, severity: 'success' });
                }
            });
        }else{
            if(data && id !== undefined){
                // if(data?.arquivo && !(data.arquivo instanceof File)){
                //     data.arquivo = helpers.base64ToFile(data.arquivo, 'arquivo');
                // }
                LegislationService.upgrade(id, data)
                .then((response) => {
                    if(response instanceof Error){
                        console.log(response.message);
                        setAlertInfo({ open: true, message: response.message + response.message, severity: 'error' });
                    }else{
                        console.log('ok');
                        setAlertInfo({ open: true, message: 'Legislação atualizada! ' + response.message, severity: 'success' });
                    }
                });   
            }
        }
    };

    const DownloadFile = () => {
        if (data?.arquivo && !(data.arquivo instanceof File)) {
            const byteCharacters = atob(data.arquivo);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' }); 
            // Cria um link temporário para o arquivo
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'arquivo.pdf'); // Nome do arquivo

            // Aciona o clique no link para fazer o download
            document.body.appendChild(link);
            link.click();

            // Remove o link após o download
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    };
    
    

    return(
        <LayoutBase title='Cadastro de Legislação'
            tollBar={
                <ToolsDetails
                    showNewButton={userData.nivel === 'adm'}
                    onClickNew={() => navigate('/legislation/novo')}
                    showDeletButton={false}
                    // showSaveButton={false}
                    onClickSave={handleSave}
                    showSaveButton={userData.nivel === 'adm'}
                />
            }
        >
            <Box padding={1}>
                <Box padding={1}>
                    <Box marginBottom={1}>
                        <Typography><strong>Legislação</strong></Typography>
                        <Divider/>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label='Nome'
                                fullWidth
                                value={data?.nome}
                                name='nome'
                                onChange={userData.nivel == 'adm' ? handleChange : undefined}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label='Descrição'
                                fullWidth
                                value={data?.descricao}
                                name='descricao'
                                onChange={userData.nivel == 'adm' ? handleChange : undefined}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label='Órgão Legislador'
                                fullWidth
                                value={data?.orgaoLegislador}
                                name='orgaoLegislador'
                                onChange={userData.nivel == 'adm' ? handleChange : undefined}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label={id == 'novo' ? 'Arquivo' : 'Novo arquivo'}
                                fullWidth
                                type='file'
                                name='arquivo'
                                // value={data?.file}
                                onChange={userData.nivel == 'adm' ? handleFileChange : undefined}
                            />
                        </Grid>
                        {data?.arquivo ? 
                            <Grid item xs={3}>
                                <Box sx={{display: 'flex', flexDirection: 'column', width: '100%', justifyItems: 'center', gap:1}}>
                                    <Typography variant='body2' align='center'>Arquivo salvo</Typography>
                                    <Button
                                        variant='contained'
                                        startIcon={<Download/>}
                                        sx={{borderRadius: '25px'}}
                                        onClick={() => DownloadFile()}
                                    >
                                        Download
                                    </Button>
                                </Box>
                            </Grid> : null    
                        }
                        
                    </Grid>
                </Box>
            </Box>
            {alertInfo.open &&
                <CustomAlert
                    message={alertInfo.message}
                    severity={alertInfo.severity}
                />
            }
        </LayoutBase>
    );
};